import { TFunction } from "i18next";

export interface TourStepConfig {
  id: string;
  target: string;
  text: string;
  position: string;
}

export const getTourSteps = (t: TFunction, isMobile: boolean): TourStepConfig[] => {
  if (isMobile) {
    return [
      {
        id: "feed",
        target: '[data-tour="feed"]',
        text: t("tourFeed"),
        position: "top",
      },
      {
        id: "search",
        target: '[data-tour="search"]',
        text: t("tourSearch"),
        position: "top",
      },
      {
        id: "favourites",
        target: '[data-tour="favourites"]',
        text: t("tourFavourites"),
        position: "top",
      },
      {
        id: "filters",
        target: '[data-tour="filters"]',
        text: t("tourFilters"),
        position: "bottom",
      },
      {
        id: "profile",
        target: '[data-tour="profile"]',
        text: t("tourProfile"),
        position: "top",
      },
    ];
  }

  return [
    {
      id: "feed",
      target: '[data-tour="feed"]',
      text: t("tourFeed"),
      position: "right",
    },
    {
      id: "search",
      target: '[data-tour="search"]',
      text: t("tourSearch"),
      position: "right",
    },
    {
      id: "favourites",
      target: '[data-tour="favourites"]',
      text: t("tourFavourites"),
      position: "right",
    },
    {
      id: "filters",
      target: '[data-tour="filters"]',
      text: t("tourFilters"),
      position: "left",
    },
  ];
};
